import React from 'react';
import { FormattedMessage } from 'react-intl';
import { OptionFormTypes } from '../../../../services/filtering/filter-form-render-service/option-form-types';
import { renderFormBasedOnType } from '../../../../services/filtering/filter-form-render-service/';
import { messages } from './messages';

export const RequestedServiceMapped = {
  id: 'requestedServiceMapped',
  displayName: <FormattedMessage {...messages.requestedServiceMapped} />,
  type: OptionFormTypes.TYPE_ORDER_COLLECTION_FILTER_OR_BLANK,
  filterValue: 'RequestedServiceMapped',
  expectsArgumentAsArray: true,

  render: (criteriaInformations, existingFiltersHelpers) => {
    return renderFormBasedOnType(OptionFormTypes.TYPE_ORDER_COLLECTION_FILTER_OR_BLANK, criteriaInformations, existingFiltersHelpers);
  },
};
